import { z } from 'zod/v4-mini';

import { cz } from '@/utils/zodUtils.ts';

export const contactFormSchema = z.object({
  firstname: z.string({ error: 'form.text.firstnameRequired' }),
  lastname: z.string({ error: 'form.text.lastnameRequired' }),
  phone: z.string({ error: 'form.required' }),
  email: z.email({ error: 'form.email.required' }),
  comment: cz.optional(z.string()),
  isEmergencyContact: z.boolean({ error: 'form.required' }),
  relationshipWithPatient: z.literal(
    [
      'grand_parent',
      'parent',
      'parent_in_law',
      'partner',
      'child',
      'brother',
      'cousin',
      'friend',
      'other',
    ],
    { error: 'form.required' },
  ),
});

export type ContactData = z.infer<typeof contactFormSchema>;
